<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-text-field placeholder="Client name" v-model="searchString"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <client-list :progress="progress('getAllClients')" :items="filteredClients" @clientSelected="handleClientSelected"/>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col>
        <v-btn color="success" @click="handleCreateClientButtonClick">Create client</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientList from '../Components/ClientList'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'Clients',
  components: {
    ClientList
  },
  data() {
    return {
      searchStringInner: null
    }
  },
  computed: {
    ...mapState('clients', {
      clients: 'clients'
    }),
    ...mapGetters('clients', {
      progress: 'progress'
    }),
    filteredClients() {
      if (this.searchStringInner === null || this.searchStringInner === '') {
        return this.clients
      }

      return _.filter(this.clients, (client) => {
        return _.toLower(client.title).includes(_.toLower(this.searchStringInner))
      })
    },
    searchString: {
      get() {
        return this.searchStringInner
      },
      set(value) {
        this.setSearchStringDebounced(value)
      }
    }
  },
  methods: {
    ...mapActions({
      getClients: 'clients/getAll',
    }),
    handleCreateClientButtonClick() {
      this.$router.push('clients/create')
    },
    handleClientSelected(clientId) {
      this.$router.push({
        path: `/clients/${clientId}`
      })
    },
    setSearchString(value) {
      this.searchStringInner = value
    },
    setSearchStringDebounced: _.debounce(function (value) {
      this.setSearchString(value)
    }, 200),
  },
  created() {
    this.getClients()
  }
}
</script>

<style scoped>

</style>